<script>
  import { page } from "@inertiajs/svelte";

  import { afterUpdate } from "svelte";

  export let form = null,
    errors,
    skip = [];

  let showError = [];
  afterUpdate(() => {
    showError = [];
    if (errors !== undefined && errors.length > 0) {
      showError = errors;
    } else if ($form) {
      showError = Object.entries($form.errors)
        .filter((v) => {
          let primary = v[0].indexOf(".");
          if (primary) {
            return !skip.includes(v[0].substring(0, primary));
          }
          return !skip.includes(v[0]);
        })
        .map((v) => {
          return v[1];
        });
    } else if (errors === undefined) {
      showError = Object.values(
        $page.props.errors?.default || $page.props.errors
      ).filter((o) => {
        return typeof o !== "object";
      });
    }
  });
</script>

{#if showError.length}
  <div class="alert alert-danger p-0">
    <ul class="mb-0 list-group list-group-flush">
      {#each showError as err}
        {#if typeof err === "string"}
          <li
            class="list-group-item bg-transparent border-secondary"
            style="--bs-border-opacity: .5;"
          >
            {@html err}
          </li>
        {/if}
      {/each}
    </ul>
  </div>
{/if}
